import api from "./api";

export const fetchAllClaims = async (page = 1, size = 10) => {
  try {
    const response = await api.get("/claim-management/all", {
      params: { page, size },
    });

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    }

    return {
      success: false,
      error: response.data?.message || "Unexpected server response",
    };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch claims",
    };
  }
};

export const reviewClaim = async (claimId, payload) => {
  try {
    const response = await api.put(
      `/claim-management/claim/${claimId}/review`,
      payload
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    }

    return {
      success: false,
      error: response.data?.message || "Unexpected server response",
    };
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        "Failed to review claim",
    };
  }
};